module.exports = __webpack_public_path__ + "img/08.11612671.png";